import { Controller } from 'stimulus';

export default class extends Controller {
    connect() {
        this.courseId = this.element.dataset.courseId;
        this.storageKey = `accordion_state_${this.courseId}`;
        this.restoreState();
        this.observeChanges();
    }

    restoreState() {
        const saved = localStorage.getItem(this.storageKey);
        if (!saved) return;

        try {
            const openSections = JSON.parse(saved);
            this.element.querySelectorAll('details.tab').forEach((details, index) => {
                if (openSections.includes(index)) {
                    details.open = true;
                }
            });
        } catch (e) {
            // ignore invalid JSON
        }
    }

    observeChanges() {
        this.element.querySelectorAll('details.tab').forEach((details) => {
            details.addEventListener('toggle', () => this.saveState());
        });
    }

    saveState() {
        const openSections = [];
        this.element.querySelectorAll('details.tab').forEach((details, index) => {
            if (details.open) {
                openSections.push(index);
            }
        });
        localStorage.setItem(this.storageKey, JSON.stringify(openSections));
    }
}
